export enum ExamCategory {
    Circulatory = "Circulatory",
    SkinCoatNails = "Skin/Coat/Nails",
    Respiratory = "Respiratory",
    Eyes = "Eyes",
    LympNodes = "Lymp Nodes",
    Ears = "Ears",
    GeneralApprearance = "General Apprearance",
    MouthDental = "Mouth/Dental",
    MucusMembranes = "Mucus Membranes",
    Musculoskeletal = "Musculoskeletal",
    ClinicCategory = "Clinic Category",
}
